import React, {useEffect, useMemo, useRef} from 'react';
import {getInstanceByDom, init, registerTheme} from 'echarts';
import {debounce} from '@/shared/lodash.debounce';
import {BaseApp} from '@/shared/BaseApp';
import dentwyzeTheme from "./res/themes/dentwyze.json";

registerTheme("dentwyzeTheme", dentwyzeTheme);

export function ChartView(
  {
    option,
    chartSettings = {useCoarsePointer: true}, // enables clicking near a line and still highlighting it
    optionSettings = {notMerge: true}, // don't merge two options together when updating option
    style = {width: '100%', height: '100%'},
    loading = false,
    events = {},
    ...props
  }) {
  const chartRef = useRef(null);

  // Debounce resize event so it only fires periodically instead of constantly
  const resizeChart = useMemo(() =>
      debounce(() => {
        if (chartRef.current) {
          const chart = getInstanceByDom(chartRef.current);
          chart.resize();
        }
      }, 100),
    []);

  useEffect(() => {
    // Initialize chart
    const chart = init(chartRef.current, BaseApp.CONTEXT.getPreferredColorScheme() === "dark" ? "dark" : "praxisTheme", chartSettings);

    // Set up event listeners
    for (const [key, handler] of Object.entries(events)) {
      chart.on(key, (param) => {
        //@ts-ignore
        handler(param);
      })
    }

    // Resize event listener
    const resizeObserver = new ResizeObserver(() => {
      resizeChart();
    })

    resizeObserver.observe(chartRef.current);

    // Return cleanup function
    return () => {
      chart?.dispose()

      if (chartRef.current) {
        resizeObserver.unobserve(chartRef.current);
      }
      resizeObserver.disconnect()
    }
  }, []);

  useEffect(() => {
    // Re-render chart when option changes
    const chart = getInstanceByDom(chartRef.current)

    chart.setOption(option, optionSettings)
  }, [option]);

  return <div ref={chartRef} style={style} {...props} />;
}